import React from 'react'
import { SwitchField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { makeStyles } from 'tss-react/mui'
import { FastField, FormProps, getIn } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

import { OrganizationSelect, PersonSelect } from '../../../../../Inputs'
import { InvestmentFormData } from './InvestmentForm.data'

export type InvestmentFormContentProps = ExtendableStyles & Testable & FormProps<InvestmentFormData>

export function InvestmentFormContent({
  className,
  'data-testid': dataTestId,
  style,
  errors,
}: InvestmentFormContentProps) {
  const { classes } = useStyles()
  const mainError = getIn(errors, 'data')

  return (
    <div className={className} data-testid={dataTestId} style={style}>
      <FastField className={classes.field} label="Person" component={PersonSelect} name="person" />
      <FastField className={classes.field} label="Organization" component={OrganizationSelect} name="organization" />

      {mainError && (
        <Typography variant="caption" color="error">
          {mainError}
        </Typography>
      )}
      <div>
        <FastField type="checkbox" component={SwitchField} label="Is lead investor" name="isLead" />
      </div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  groupFields: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  roundTypeSelector: {
    flex: '1 1 auto',
    marginRight: spacing(),
  },
  doubleFieldWrapper: {
    display: 'grid',
    gridGap: spacing(),
    gridTemplateColumns: '1fr 1fr',
    marginBottom: spacing(2),
  },
  field: {
    marginBottom: spacing(2),
  },
}))
